import { Col, Row, Typography } from 'antd';
import React from 'react';

function InfoWidget(props: any) {
  const { item, itemKey } = props;
  const { value, name } = item;
  const isItPercent = typeof value?.defaultValue?.percent === 'number';
  const valueWidget = isItPercent
    ? value?.defaultValue?.percent === 0
      ? `${value?.defaultValue?.percent}%`
      : `${value?.defaultValue?.percent}0%`
    : `${value?.defaultValue?.amount?.currency} ${value?.defaultValue?.amount?.value}.00`;

  return (
    <Row key={`${itemKey}-row`} justify="space-between">
      <Col key={`${itemKey}-colname`}>{name}</Col>
      <Col key={`${itemKey}-coltitle`}>
        <Typography.Title key={`${itemKey}-rowTitle`} level={5} style={{ fontSize: '13px' }}>
          {valueWidget}
        </Typography.Title>
      </Col>
    </Row>
  );
}
export default InfoWidget;
